import React from "react";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { Name } from "./features/name/Name";
import { Company } from "./features/company/Company";
import { Address } from "./features/address/Address";
import { Email } from "./features/email/Email";
import { Telephone } from "./features/telephone/Telephone";
import { CustomerCountry } from "./features/customercountry/Customercountry";
import { Subject } from "./features/subject/Subject";
import { Message } from "./features/message/Message";
import { Bussinesstype } from "./features/businesstype/Bussinesstype";
import { Country } from "./features/country/Country";
import { Productgroup } from "./features/productgroup/Productgroup";
import { Producttype } from "./features/producttype/Producttype";
import { Attachedfile } from "./features/attachedfile/Attachedfile";
import { SubmitButton } from "./features/submitButton/SubmitButton";
//import { set as companySet } from "./features/company/companySlice";
import { initialList as businesstypeInitialList } from "./features/businesstype/bussinesstypeSlice";
import { initialList as countryInitialList } from "./features/country/countrySlice";
import {
  // selectLanguage,
  selectLanguage,
  set as languageSet,
} from "./features/language/languageSlice";
import { RequestProduct } from "./features/requestProduct/Requestproduct";
import {
  initialList as productgroupInitialList,
  initialBuMappingMaster,
} from "./features/productgroup/productgroupSlice";
import {
  // set as setCustomerCountry,
  initialList as CustomerCountryInitialList,
  initialListProvince,
} from "./features/customercountry/customercountrySlice";
import { set as scgBuSet } from "./features/scgbu/scgbuSlice";
import {useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import * as getleadmasterApi from "./utils/getleadmasterApi";
import "./App.css";
import { SnackAlert } from "./features/snackAlert/SnackAlert";
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "scgregular",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  buttonContainer:{
    margin:"auto"
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

function App() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [leadData, setleadData] = React.useState({});
  const [isInitial, setisInitial] = React.useState(true);
  const lang = useSelector(selectLanguage);
  if (isInitial) {
    setisInitial(false);
    setleadData(getleadmasterApi.getleadMaster());
    getleadmasterApi
      .getleadMaster()
      .then((leadmasterData) => {
        // console.log("Lead : -------------------->\n" + leadmasterData);
        setleadData(leadmasterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  React.useEffect(() => {
    // console.log("USE EFFECT");
    //console.log(JSON.stringify(leadData.Country));
    // console.log(JSON.stringify(leadData.ProductMaster));
    if (leadData.Country !== undefined)
    {
      if(lang==="TH")
      {
        let tmpcountry = leadData.Country.filter(c=>c.Name!=="Thailand");
        let sortedcountry = tmpcountry.sort((a, b) => a.NameTH.localeCompare(b.NameTH))
        dispatch(countryInitialList([leadData.Country.filter(c=>c.Name==="Thailand")[0],...sortedcountry]));
      }
      else
      {
        let tmpcountry = leadData.Country.filter(c=>c.Name!=="Thailand");
        let sortedcountry = tmpcountry.sort((a, b) => a.Name.localeCompare(b.Name))
        dispatch(countryInitialList([leadData.Country.filter(c=>c.Name==="Thailand")[0],...sortedcountry]));
      }
     
    }
     
    if (leadData.ProductMaster !== undefined)
      dispatch(productgroupInitialList(leadData.ProductMaster));
    if (leadData.CustomerBusinessType !== undefined)
      dispatch(businesstypeInitialList(leadData.CustomerBusinessType));
    if (leadData.CustomerCountry !== undefined) {
      if(lang==="TH")
      {
        let tmpcountry = leadData.Country.filter(c=>c.Name!=="Thailand");
        let sortedcountry = tmpcountry.sort((a, b) => a.NameTH.localeCompare(b.NameTH))
        dispatch(CustomerCountryInitialList([leadData.Country.filter(c=>c.Name==="Thailand")[0],...sortedcountry]));
      }
      else
      {
        let tmpcountry = leadData.Country.filter(c=>c.Name!=="Thailand");
        let sortedcountry = tmpcountry.sort((a, b) => a.Name.localeCompare(b.Name))
        dispatch(CustomerCountryInitialList([leadData.Country.filter(c=>c.Name==="Thailand")[0],...sortedcountry]));
      }
    }
    if (leadData.BusinessUnit !== undefined) {
      dispatch(initialBuMappingMaster(leadData.BusinessUnit));
    }
    if (leadData.CustomerProvince !== undefined)
      dispatch(initialListProvince(leadData.CustomerProvince));
  }, [leadData,lang]);

  //dispatch(businesstypeInitialList(["hitachi Solution", "HAS THAI"]));
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let language = params.get("language");
  language = language === null ? "TH" : language;
  //console.log(language);
  dispatch(languageSet(language.toUpperCase()));
  let scgbu = params.get("bu");
  //console.log(scgbu?.toUpperCase());
  if (scgbu === "FC") {
    var subject = (
      <Grid item xs={12}>
        <Subject />
      </Grid>
    );
  }
  scgbu = scgbu !== null ? dispatch(scgBuSet(scgbu.toUpperCase())) : "default";

  //console.log(masterData);
  return (
    //<div className="snow-bg">
    <ThemeProvider theme={theme}>
      <div className="App">
        <header className="App-header">
          {/* 
        <img src={logo} className="App-logo" alt="logo" />
        */}

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <Name />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <Company />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <Email />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <Telephone />
            </Grid>
            <Grid item xs={12}>
              <Address />
            </Grid>
            <Grid item xs={12}>
              <CustomerCountry />
            </Grid>
            {subject}
            <Grid item xs={12}>
              <Bussinesstype />
            </Grid>
            <Grid item xs={12}>
              <Country />
            </Grid>
            <Grid item xs={12}>
              <Productgroup />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
              <Producttype />
            </Grid>{" "}
            <Grid item xs={12} sm={6} md={6} lg={8} xl={9}>
              <RequestProduct />
            </Grid>
            <Grid item xs={12}>
              <Message />
            </Grid>
            <Grid container xs={12} spacing={3} className={classes.buttonContainer}>
              <Grid item xs={6}>
              <Attachedfile />
            </Grid>
            <Grid item xs={6}>
              <SubmitButton />
            </Grid>
            </Grid>
          </Grid>
          <SnackAlert />
        </header>{" "}
      </div>
    </ThemeProvider> //</div>
  );
}

export default App;
